// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/universal.css'; // Universal button/input styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './context/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store'; // <-- Import your Redux store

// Add Google Fonts dynamically
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@500;800&family=Poppins:wght@400;600&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap the entire app with the Redux Provider */}
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <App />
        </Router>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app,
// pass a function to log results (e.g. reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
